import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { bufferedReporter, setReporter, startSentry } from './lib/errors';
import './styles/index.css';

// Sentry only with a DSN: its own chunk (~29 kB gzip), fetched once the browser is idle so it
// never competes with the first screen; errors before it wait in a buffer.
const dsn = import.meta.env.VITE_SENTRY_DSN;
const idle = () =>
  new Promise<void>((resolve) =>
    'requestIdleCallback' in window
      ? requestIdleCallback(() => resolve(), { timeout: 4000 })
      : setTimeout(resolve, 2000),
  );
if (dsn)
  setReporter(
    bufferedReporter(
      idle().then(() =>
        startSentry({
          dsn,
          environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
          release: import.meta.env.VITE_RELEASE || undefined,
        }),
      ),
    ),
  );

// The shell scrolls to the top on every navigation, back/forward included (the prototype's
// behaviour); the browser's own restoration would fight it.
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
